import React, { HTMLAttributes } from 'react'
import RSwitch, { ReactSwitchProps } from 'react-switch'
import './index.scss'
import clsx from 'clsx'

export function SwitchContainer({
	className,
	...rest
}: HTMLAttributes<HTMLDivElement>) {
	return <div className={clsx('switch-container', className)} {...rest} />
}

export function SwitchLabel({
	className,
	...rest
}: HTMLAttributes<HTMLSpanElement>) {
	return <span className={clsx('switch-label', className)} {...rest} />
}

export function SwitchField(
	props: Omit<ReactSwitchProps, 'uncheckedIcon' | 'checkedIcon'>,
) {
	return (
		<RSwitch
			uncheckedIcon={false}
			checkedIcon={false}
			onColor="#de996f"
			width={64}
			height={32}
			{...props}
		/>
	)
}

export const Switch = {
	Container: SwitchContainer,
	Label: SwitchLabel,
	Field: SwitchField,
}
